import React, { useState, useEffect } from "react"
import { graphql } from "gatsby"
import { TransitionStatus } from "react-transition-group/Transition"
import { PageProps } from "gatsby"

import Layout, { MyLocationEnum } from "../components/Layout"
import SEO, { MetaOG } from "../components/Seo"
import MobileStoryRoom from "../components/StoryRooms/MobileStoryRoom"
import BannerImage from "../images/haustradstefnaSocial.png"

import {
  ChatEmbed,
  ChatSideBar,
  useChat,
  CHAT_NAME,
  SubroomNameEnum
} from '../components/Chat'
import styled from "styled-components"

import ChatMobile from "../components/Chat/ChatMobile"

const LazyApp = React.lazy(() => import('../components/App/App'));

interface StoryRoomProps {
  data: any,
  location: PageProps,
  transitionStatus: TransitionStatus,
}

export default ({ data, location, transitionStatus }: StoryRoomProps) => {
  const seo_og: MetaOG = {
    title: "Fyrsta hæð",
    description: "",
  }

  const [showMobile, setShowMobile] = useState(false)
  useEffect(() => {
    var resp = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent)
    setShowMobile(resp)
  })

  const {
    chatNickname
  } = useChat()

  const isSSR = typeof window === "undefined"

  if (!showMobile) {
    return (
      <Layout
        myLocation={MyLocationEnum.FyrstaHaed}
        location={location}
        transitionStatus={transitionStatus}
        showMessage={true}
      >
        {({ infoOpen, messageOpen, setMessageOpen }) => (
          <>
            <SEO
              title="Fyrsta hæð"
              description=""
              og={seo_og}
            />

            <ChatSideBar onClose={() => setMessageOpen(false)} show={messageOpen}>
              {chatNickname.fetching === false && (
                <ChatEmbed
                  chatName={CHAT_NAME}
                  nickname={chatNickname.nickname}
                  subroom={SubroomNameEnum.FyrstahaedBistroFacilities}
                />
              )}
            </ChatSideBar>

            {!isSSR && (
              <React.Suspense fallback={<div />}>
                <LazyApp
                  data={data}
                  transitionStatus={transitionStatus}
                  tileSize="300px"
                />
              </React.Suspense>
            )}
          </>
        )}

      </Layout>
    )
  }
  else {
    return (
      <LayoutMobile
        myLocation={MyLocationEnum.FyrstaHaed}
        location={location}
        transitionStatus={transitionStatus}
      >
        <SEO
          title="Fyrsta hæð"
          og={seo_og}
        />

        {chatNickname.fetching === false && (
          <ChatMobile>
            <ChatEmbed
              chatName={CHAT_NAME}
              nickname={chatNickname.nickname}
              subroom={SubroomNameEnum.FyrstahaedBistroFacilities}
            />
          </ChatMobile>
        )}

      </LayoutMobile>
    )
  }
}

const LayoutMobile = styled(Layout)`
  background: #5166E7;
`

export const query = graphql`
  query {
    ceiling: file(relativePath: { eq: "Loft-1.png" }) {
      childImageSharp {
        fluid(maxWidth: 1500, quality: 50) {
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }
    floor: file(relativePath: { eq: "squoosh_roomFloor.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 1500, quality: 50) {
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }
    concreteWall: file(relativePath: { eq: "tron-seamless.png" }) {
      childImageSharp {
        fluid(maxWidth: 1500, quality: 50) {
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }
    allRoom(filter: {roomName: {eq: "fyrstahaed-bistro-facilities"}}) {
      edges {
        node {
          thirdImageNode {
            publicURL
          }
        }
      }
    }
  } 
`